export default __webpack_public_path__ + "static/media/jcb.a01f6a3a.svg";